module.exports = __webpack_public_path__ + "static/logo-the-heart-37e754bbcbd3c14fdafed168d5e925b3.svg";